import type { ProfileResource } from '@medplum/core';

/**
 * True for FHIR profiles that represent a human user in the Unify app.
 * OAuth `client_credentials` sets profile to ClientApplication — not interactive.
 */
export function isInteractiveUserProfile(profile: ProfileResource | undefined | null): boolean {
  if (!profile) return false;
  const rt = profile.resourceType;
  return rt === 'Patient' || rt === 'Practitioner' || rt === 'RelatedPerson';
}
